export default {
    name: 'Join',
    data() {
        return {
            members: [
                {
                    name: 'Josh',
                    bio:
                        'Josh is 16 years old and is the current CEO of Subsea Rovers. His interests include aviation, history, and government. Josh joined SubSea Rovers because he enjoys helping  take shape.'
                },
                {
                    name: 'Carter',
                    bio:
                        'Carter is a 17-year-old high school senior and the lead software engineer of Subsea Rovers. He enjoys programming, making music, and performing musical theater. Mainly experienced in Python, he’s also learning more about graphic design, web development, and artificial intelligence.'
                },
                {
                    name: 'Emily',
                    bio:
                        'Emily is 15 years old and is the project manager of Subsea Rovers. She joined Subsea Rovers to learn more about robotics. Some of her interests are reading, writing, playing piano and violin, and organizing things.'
                },
                {
                    name: 'Josh',
                    bio:
                        'Josh is a high school student who recently became interested in robotics. Along with his interest in robotics he enjoys; Hiking, backpacking, sword fighting, archery, and graphic design. He joined Sub Sea Rovers so he can gain basic knowledge of robots so he can become a robotic engineer that specializes in prosthetics.'
                },
                {
                    name: 'Ben',
                    bio:
                        'Ben is a 19 year old College Freshman. This is his second year with the team, and his first as CFO. His interests include Robotics and Engineering, designing and building things, and learning new things in a wide variety of fields. He plans to pursue a degree in Mechanical Engineering, either at Sac State, CBU, or the California Maritime Academy.'
                },
                {
                    name: 'Gus',
                    bio:
                        'Gus is 14 years old and has interests in robots, 3d printers, and drones. He joined Subsea Rovers because he enjoys programing and building robots.'
                },
                {
                    name: 'Noah',
                    bio:
                        'Noah is in charge of making this beautiful website you are currently looking at. He is the most recent member of the team and looks forward to learning more about the ROV and to possibly help program it.'
                }
            ]
        };
    },
    mounted: function() {
        document.getElementById('navBar').style.marginTop = '0px';
    }
};



// WEBPACK FOOTER //
// ./src/components/join/join.js